import type { NodeType, WireType } from '../sim/types';

export const COLORS = {
  bg: 0x05060d,
  bgGlow: 0x0d0e1a,
  bgGridFar: 0x0e1a32,
  bgGridNear: 0x1a2a52,
  vignette: 0x000004,

  textPrimary: 0xeaf2ff,
  textDim: 0x6a728f,
  textWarn: 0xff5577,
  textOk: 0x66ffaa,

  pulse: 0xeaffff,
  pulseTrail: 0x88e8ff,
  collapseBurst: 0xffffff,

  wireDim: 0x1f2840,
  wireActive: 0x6a8cff,
  wireForbidden: 0x6a1530,
  wireLocked: 0x2a3050,
  wireBurn: 0xa84830,
} as const;

export interface NodeStyle {
  fill: number;
  ring: number;
  ringActive: number;
}

const N: Record<NodeType, NodeStyle> = {
  normal:    { fill: 0x10162a, ring: 0x4a5a96, ringActive: 0x8aa6ff },
  required:  { fill: 0x062234, ring: 0x1eb5ff, ringActive: 0x6cf0ff },
  protected: { fill: 0x2a0612, ring: 0xff3366, ringActive: 0xff88aa },
  relay:     { fill: 0x2a1d04, ring: 0xffaa1c, ringActive: 0xffe080 },
  shield:    { fill: 0x05281a, ring: 0x44ff88, ringActive: 0xb0ffcc },
  splitter:  { fill: 0x2a0628, ring: 0xff66cc, ringActive: 0xffaae0 },
  capacitor: { fill: 0x2a2604, ring: 0xffee44, ringActive: 0xffff99 },
  core:      { fill: 0x1a0535, ring: 0xcc44ff, ringActive: 0xeeaaff },
};

export function nodeStyle(type: NodeType): NodeStyle {
  return N[type];
}

export interface WireStyle {
  color: number;
  width: number;
  dashed: boolean;
  arrow: boolean;
}

const W: Record<WireType, WireStyle> = {
  normal:      { color: 0x4a6cc0, width: 3, dashed: false, arrow: false },
  delay:       { color: 0xd09a3a, width: 3, dashed: true,  arrow: false },
  directional: { color: 0x5ab0e0, width: 3, dashed: false, arrow: true },
  locked:      { color: 0x404868, width: 3, dashed: true,  arrow: false },
  burn:        { color: 0xc4633a, width: 3, dashed: false, arrow: false },
  forbidden:   { color: 0xff3366, width: 4, dashed: true,  arrow: true },
};

export function wireStyle(type: WireType): WireStyle {
  return W[type];
}

export const TIMING = {
  tickMs: 320,
  collapseFlashMs: 220,
  pulseEmitFlashMs: 120,
} as const;
